import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

const ContactoPage = () => {
  const [formData, setFormData] = useState({
    nombre: '',
    telefono: '',
    email: '',
    tipoInmueble: '',
    metrosCuadrados: '',
    barrio: '',
    estadoActual: '',
    muebles: '',
    urgencia: '',
    acabado: '',
    mensaje: '',
  });

  const [submitStatus, setSubmitStatus] = useState<'idle' | 'sending' | 'success' | 'error'>('idle');

  const testimonios = [
    {
      nombre: 'María González',
      ubicacion: 'Sants, Barcelona',
      texto: 'Excelente trabajo pintando mi piso. Muy limpios y profesionales. El resultado superó mis expectativas. Totalmente recomendable.',
      avatar: 'https://public.readdy.ai/ai/img_res/2c5e2fec76d2bc225abb73d42f15bff7.jpg',
    },
    {
      nombre: 'Carlos Martín',
      ubicacion: 'Eixample, Barcelona',
      texto: 'Profesionales de confianza. Alisaron el gotelé de todo el piso y quedó perfecto. Precio justo y entrega puntual.',
      avatar: 'https://readdy.ai/api/search-image?query=professional%20portrait%20spanish%20man%20smiling%20business%20casual%20friendly&width=100&height=100&seq=testimonial-carlos-1&orientation=squarish',
    },
    {
      nombre: 'Laura Vidal',
      ubicacion: 'Gràcia, Barcelona',
      texto: 'Pintaron mi local comercial en tiempo récord. Muy atentos a los detalles y respetaron los horarios acordados.',
      avatar: 'https://readdy.ai/api/search-image?query=professional%20portrait%20spanish%20woman%20smiling%20business%20casual%20friendly&width=100&height=100&seq=testimonial-laura-1&orientation=squarish',
    },
  ];

  useEffect(() => {
    const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';
    
    document.title = 'Contacto | Solicitar Presupuesto | PINTORDECO Barcelona';
    
    // Update canonical URL
    const canonicalLink = document.querySelector('link[rel="canonical"]');
    if (canonicalLink) {
      canonicalLink.setAttribute('href', `${siteUrl}/contacto`);
    }
    
    // Update Open Graph meta tags
    const ogUrl = document.querySelector('meta[property="og:url"]');
    if (ogUrl) {
      ogUrl.setAttribute('content', `${siteUrl}/contacto`);
    }
    
    const ogTitle = document.querySelector('meta[property="og:title"]');
    if (ogTitle) {
      ogTitle.setAttribute('content', 'Contacto | Solicitar Presupuesto | PINTORDECO Barcelona');
    }
    
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'Contacta con PINTORDECO Barcelona. Solicita presupuesto gratis de pintura. Tel: 690 22 09 44. Respuesta en menos de 24h.');
    }
    
    const ogDescription = document.querySelector('meta[property="og:description"]');
    if (ogDescription) {
      ogDescription.setAttribute('content', 'Contacta con PINTORDECO Barcelona. Solicita presupuesto gratis de pintura. Tel: 690 22 09 44. Respuesta en menos de 24h.');
    }

    const metaKeywords = document.querySelector('meta[name="keywords"]');
    if (metaKeywords) {
      metaKeywords.setAttribute('content', 'contacto pintor Barcelona, presupuesto pintura Barcelona, solicitar presupuesto, pintor Barcelona contacto');
    }

    // Structured Data - ContactPage
    const scriptLD = document.createElement('script');
    scriptLD.type = 'application/ld+json';
    scriptLD.text = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "ContactPage",
      "@id": `${siteUrl}/contacto#webpage`,
      "url": `${siteUrl}/contacto`,
      "name": "Contacto | PINTORDECO Barcelona",
      "description": "Contacta con PINTORDECO Barcelona. Solicita presupuesto gratis de pintura.",
      "inLanguage": "es-ES",
      "isPartOf": {
        "@type": "WebSite",
        "@id": `${siteUrl}/#website`,
        "url": siteUrl,
        "name": "PINTORDECO Barcelona"
      },
      "mainEntity": {
        "@type": "LocalBusiness",
        "@id": `${siteUrl}/#organization`,
        "name": "PINTORDECO Barcelona",
        "telephone": "+34690220944",
        "address": {
          "@type": "PostalAddress",
          "streetAddress": "Carrer de Sant Eloi, 2, B",
          "addressLocality": "Barcelona",
          "addressRegion": "Barcelona",
          "postalCode": "08038",
          "addressCountry": "ES"
        },
        "openingHoursSpecification": [
          {
            "@type": "OpeningHoursSpecification",
            "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
            "opens": "08:00",
            "closes": "20:00"
          },
          {
            "@type": "OpeningHoursSpecification",
            "dayOfWeek": "Saturday",
            "opens": "09:00",
            "closes": "14:00"
          }
        ]
      }
    });
    document.head.appendChild(scriptLD);
    
    return () => {
      if (scriptLD.parentNode) {
        scriptLD.parentNode.removeChild(scriptLD);
      }
    };
  }, []);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setSubmitStatus('sending');

    try {
      const formBody = new URLSearchParams();
      Object.entries(formData).forEach(([key, value]) => {
        if (value) formBody.append(key, value);
      });

      const response = await fetch('https://readdy.ai/api/form/d5nmtk0f4392hm13o5cg', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: formBody.toString(),
      });

      if (response.ok) {
        setSubmitStatus('success');
        setFormData({
          nombre: '',
          telefono: '',
          email: '',
          tipoInmueble: '',
          metrosCuadrados: '',
          barrio: '',
          estadoActual: '',
          muebles: '',
          urgencia: '',
          acabado: '',
          mensaje: '',
        });
      } else {
        setSubmitStatus('error');
      }
    } catch (error) {
      setSubmitStatus('error');
    }

    setTimeout(() => setSubmitStatus('idle'), 5000);
  };

  return (
    <div className="min-h-screen bg-white">
      <Navbar />

      {/* Hero */}
      <section className="pt-32 pb-12 bg-gradient-to-br from-primary/5 to-accent/5">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <nav className="text-sm text-gray-500 mb-6">
            <Link to="/" className="hover:text-accent cursor-pointer">Inicio</Link>
            <span className="mx-2">/</span>
            <span className="text-primary font-semibold">Contacto</span>
          </nav>

          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
          >
            <h1 className="text-5xl lg:text-6xl font-bold text-primary mb-6 leading-tight">
              Solicita tu presupuesto
            </h1>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Cuéntanos sobre tu <Link to="/servicios" className="text-gray-600 hover:text-accent transition-colors underline">proyecto de pintura en Barcelona</Link>. Te respondemos en menos de 24 horas con un presupuesto detallado y personalizado. <Link to="/faq" className="text-gray-600 hover:text-accent transition-colors underline">Consulta las preguntas frecuentes</Link>.
            </p>
          </motion.div>
        </div>
      </section>

      {/* Contenido Principal */}
      <section className="py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid lg:grid-cols-2 gap-12">
            {/* Información de Contacto */}
            <motion.div
              initial={{ opacity: 0, x: -30 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.8 }}
            >
              <h2 className="text-3xl font-bold text-primary mb-6">
                Información de contacto
              </h2>
              <p className="text-gray-600 mb-8">
                Estamos a tu disposición para resolver tus dudas y ofrecerte el mejor <Link to="/" className="text-gray-600 hover:text-accent transition-colors underline">servicio de pintura profesional en Barcelona</Link>. Conoce más sobre <Link to="/empresa" className="text-gray-600 hover:text-accent transition-colors underline">nuestro equipo y experiencia</Link>.
              </p>

              <div className="space-y-6 mb-8">
                <div className="flex items-start space-x-4">
                  <div className="w-12 h-12 bg-accent rounded-xl flex items-center justify-center flex-shrink-0">
                    <i className="ri-phone-line text-2xl text-white"></i>
                  </div>
                  <div>
                    <h3 className="font-bold text-primary mb-1">Teléfono</h3>
                    <a href="tel:+34690220944" className="text-gray-700 hover:text-accent cursor-pointer text-lg">
                      +34 690 22 09 44
                    </a>
                    <p className="text-sm text-gray-500 mt-1">L-V: 8:00-20:00, S: 9:00-14:00</p>
                  </div>
                </div>

                <div className="flex items-start space-x-4">
                  <div className="w-12 h-12 bg-accent rounded-xl flex items-center justify-center flex-shrink-0">
                    <i className="ri-whatsapp-line text-2xl text-white"></i>
                  </div>
                  <div>
                    <h3 className="font-bold text-primary mb-1">WhatsApp</h3>
                    <a
                      href="https://wa.me/34690220944"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-gray-700 hover:text-accent cursor-pointer text-lg"
                    >
                      +34 690 22 09 44
                    </a>
                    <p className="text-sm text-gray-500 mt-1">Respuesta rápida</p>
                  </div>
                </div>

                <div className="flex items-start space-x-4">
                  <div className="w-12 h-12 bg-accent rounded-xl flex items-center justify-center flex-shrink-0">
                    <i className="ri-map-pin-line text-2xl text-white"></i>
                  </div>
                  <div>
                    <h3 className="font-bold text-primary mb-1">Dirección</h3>
                    <p className="text-gray-700">
                      Carrer de Sant Eloi, 2, B<br />
                      Sants-Montjuïc<br />
                      08038 Barcelona
                    </p>
                  </div>
                </div>

                <div className="flex items-start space-x-4">
                  <div className="w-12 h-12 bg-accent rounded-xl flex items-center justify-center flex-shrink-0">
                    <i className="ri-time-line text-2xl text-white"></i>
                  </div>
                  <div>
                    <h3 className="font-bold text-primary mb-1">Horario de atención</h3>
                    <p className="text-gray-700">
                      Lunes a Viernes: 8:00 - 20:00<br />
                      Sábado: 9:00 - 14:00<br />
                      <span className="text-sm text-gray-500">(Confirmar disponibilidad)</span>
                    </p>
                  </div>
                </div>
              </div>

              {/* Mapa */}
              <div className="rounded-2xl overflow-hidden shadow-lg h-80">
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2994.0!2d2.1493607!3d41.3759799!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zNDHCsDIyJzMzLjUiTiAywrAwOCc1Ny43IkU!5e0!3m2!1ses!2ses!4v1234567890"
                  width="100%"
                  height="100%"
                  style={{ border: 0 }}
                  allowFullScreen
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                  title="Mapa de ubicación PINTORDECO Barcelona"
                ></iframe>
              </div>
            </motion.div>

            {/* Formulario */}
            <motion.div
              initial={{ opacity: 0, x: 30 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.8 }}
            >
              <div className="bg-white rounded-3xl shadow-2xl p-8 border border-gray-100">
                <h2 className="text-2xl font-bold text-primary mb-6">
                  Cuéntanos sobre tu proyecto
                </h2>

                <form onSubmit={handleSubmit} data-readdy-form id="contacto-form">
                  <div className="space-y-4">
                    {/* Nombre */}
                    <div>
                      <label htmlFor="nombre" className="block text-sm font-semibold text-gray-700 mb-2">
                        Nombre completo *
                      </label>
                      <input
                        type="text"
                        id="nombre"
                        name="nombre"
                        value={formData.nombre}
                        onChange={handleChange}
                        required
                        className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:border-accent focus:ring-2 focus:ring-accent/20 focus:outline-none transition-all"
                        placeholder="Tu nombre"
                      />
                    </div>

                    {/* Teléfono y Email */}
                    <div className="grid md:grid-cols-2 gap-4">
                      <div>
                        <label htmlFor="telefono" className="block text-sm font-semibold text-gray-700 mb-2">
                          Teléfono *
                        </label>
                        <input
                          type="tel"
                          id="telefono"
                          name="telefono"
                          value={formData.telefono}
                          onChange={handleChange}
                          required
                          className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:border-accent focus:ring-2 focus:ring-accent/20 focus:outline-none transition-all"
                          placeholder="690 22 09 44"
                        />
                      </div>
                      <div>
                        <label htmlFor="email" className="block text-sm font-semibold text-gray-700 mb-2">
                          Email *
                        </label>
                        <input
                          type="email"
                          id="email"
                          name="email"
                          value={formData.email}
                          onChange={handleChange}
                          required
                          className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:border-accent focus:ring-2 focus:ring-accent/20 focus:outline-none transition-all"
                          placeholder="tu@email.com"
                        />
                      </div>
                    </div>

                    {/* Tipo de inmueble */}
                    <div>
                      <label htmlFor="tipoInmueble" className="block text-sm font-semibold text-gray-700 mb-2">
                        Tipo de inmueble *
                      </label>
                      <select
                        id="tipoInmueble"
                        name="tipoInmueble"
                        value={formData.tipoInmueble}
                        onChange={handleChange}
                        required
                        className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:border-accent focus:ring-2 focus:ring-accent/20 focus:outline-none transition-all cursor-pointer"
                      >
                        <option value="">Selecciona una opción</option>
                        <option value="Piso">Piso</option>
                        <option value="Casa">Casa</option>
                        <option value="Local comercial">Local comercial</option>
                        <option value="Oficina">Oficina</option>
                        <option value="Otro">Otro</option>
                      </select>
                    </div>

                    {/* Metros cuadrados y Barrio */}
                    <div className="grid md:grid-cols-2 gap-4">
                      <div>
                        <label htmlFor="metrosCuadrados" className="block text-sm font-semibold text-gray-700 mb-2">
                          Metros cuadrados aproximados
                        </label>
                        <input
                          type="number"
                          id="metrosCuadrados"
                          name="metrosCuadrados"
                          value={formData.metrosCuadrados}
                          onChange={handleChange}
                          className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:border-accent focus:ring-2 focus:ring-accent/20 focus:outline-none transition-all"
                          placeholder="60"
                        />
                      </div>
                      <div>
                        <label htmlFor="barrio" className="block text-sm font-semibold text-gray-700 mb-2">
                          Barrio / Municipio *
                        </label>
                        <input
                          type="text"
                          id="barrio"
                          name="barrio"
                          value={formData.barrio}
                          onChange={handleChange}
                          required
                          className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:border-accent focus:ring-2 focus:ring-accent/20 focus:outline-none transition-all"
                          placeholder="Ej: Sants, Barcelona"
                        />
                      </div>
                    </div>

                    {/* Estado actual */}
                    <div>
                      <label htmlFor="estadoActual" className="block text-sm font-semibold text-gray-700 mb-2">
                        Estado actual
                      </label>
                      <select
                        id="estadoActual"
                        name="estadoActual"
                        value={formData.estadoActual}
                        onChange={handleChange}
                        className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:border-accent focus:ring-2 focus:ring-accent/20 focus:outline-none transition-all cursor-pointer"
                      >
                        <option value="">Selecciona una opción</option>
                        <option value="Nuevo">Nuevo</option>
                        <option value="Buen estado">Buen estado</option>
                        <option value="Regular">Regular</option>
                        <option value="Necesita reparación">Necesita reparación</option>
                      </select>
                    </div>

                    {/* Muebles */}
                    <div>
                      <label className="block text-sm font-semibold text-gray-700 mb-2">
                        ¿Hay muebles?
                      </label>
                      <div className="flex space-x-4">
                        {['Sí', 'No', 'Parcialmente'].map((option) => (
                          <label key={option} className="flex items-center space-x-2 cursor-pointer">
                            <input
                              type="radio"
                              name="muebles"
                              value={option}
                              checked={formData.muebles === option}
                              onChange={handleChange}
                              className="w-4 h-4 text-accent focus:ring-accent cursor-pointer"
                            />
                            <span className="text-gray-700">{option}</span>
                          </label>
                        ))}
                      </div>
                    </div>

                    {/* Urgencia y Acabado */}
                    <div className="grid md:grid-cols-2 gap-4">
                      <div>
                        <label htmlFor="urgencia" className="block text-sm font-semibold text-gray-700 mb-2">
                          Urgencia
                        </label>
                        <select
                          id="urgencia"
                          name="urgencia"
                          value={formData.urgencia}
                          onChange={handleChange}
                          className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:border-accent focus:ring-2 focus:ring-accent/20 focus:outline-none transition-all cursor-pointer"
                        >
                          <option value="">Selecciona</option>
                          <option value="Normal">Normal</option>
                          <option value="1-2 semanas">1-2 semanas</option>
                          <option value="Urgente">Urgente</option>
                        </select>
                      </div>
                      <div>
                        <label htmlFor="acabado" className="block text-sm font-semibold text-gray-700 mb-2">
                          Acabado deseado
                        </label>
                        <select
                          id="acabado"
                          name="acabado"
                          value={formData.acabado}
                          onChange={handleChange}
                          className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:border-accent focus:ring-2 focus:ring-accent/20 focus:outline-none transition-all cursor-pointer"
                        >
                          <option value="">Selecciona</option>
                          <option value="Mate">Mate</option>
                          <option value="Satinado">Satinado</option>
                          <option value="Brillo">Brillo</option>
                          <option value="No sé">No sé</option>
                        </select>
                      </div>
                    </div>

                    {/* Mensaje */}
                    <div>
                      <label htmlFor="mensaje" className="block text-sm font-semibold text-gray-700 mb-2">
                        Mensaje adicional
                      </label>
                      <textarea
                        id="mensaje"
                        name="mensaje"
                        value={formData.mensaje}
                        onChange={handleChange}
                        rows={4}
                        maxLength={500}
                        className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:border-accent focus:ring-2 focus:ring-accent/20 focus:outline-none transition-all resize-none"
                        placeholder="Cuéntanos más detalles sobre tu proyecto... (máximo 500 caracteres)"
                      ></textarea>
                      <p className="text-xs text-gray-500 mt-1">
                        {formData.mensaje.length}/500 caracteres
                      </p>
                    </div>

                    {/* Checkbox de privacidad */}
                    <div className="flex items-start space-x-2">
                      <input
                        type="checkbox"
                        id="privacidad"
                        required
                        className="w-4 h-4 mt-1 text-accent focus:ring-accent cursor-pointer"
                      />
                      <label htmlFor="privacidad" className="text-sm text-gray-600 cursor-pointer">
                        He leído y acepto la{' '}
                        <a href="#" className="text-accent hover:underline">
                          política de privacidad
                        </a>
                      </label>
                    </div>

                    {/* Botón de envío */}
                    <button
                      type="submit"
                      disabled={submitStatus === 'sending'}
                      className="whitespace-nowrap w-full px-8 py-4 bg-accent text-white rounded-full font-bold text-lg hover:bg-accent/90 transition-all cursor-pointer shadow-lg disabled:opacity-50 disabled:cursor-not-allowed"
                    >
                      {submitStatus === 'sending' ? (
                        <span className="flex items-center justify-center space-x-2">
                          <i className="ri-loader-4-line animate-spin"></i>
                          <span>Enviando...</span>
                        </span>
                      ) : (
                        'Enviar solicitud'
                      )}
                    </button>

                    {/* Mensajes de estado */}
                    {submitStatus === 'success' && (
                      <div className="bg-green-50 border border-green-200 rounded-lg p-4 text-green-800">
                        <i className="ri-checkbox-circle-line mr-2"></i>
                        ¡Solicitud enviada! Te responderemos en menos de 24 horas.
                      </div>
                    )}

                    {submitStatus === 'error' && (
                      <div className="bg-red-50 border border-red-200 rounded-lg p-4 text-red-800">
                        <i className="ri-error-warning-line mr-2"></i>
                        Error al enviar. Por favor, intenta de nuevo o contáctanos por teléfono.
                      </div>
                    )}

                    <p className="text-sm text-gray-500 text-center">
                      Te responderemos en menos de 24 horas con tu presupuesto personalizado
                    </p>
                  </div>
                </form>
              </div>
            </motion.div>
          </div>
        </div>
      </section>

      {/* Métodos de Contacto Alternativos */}
      <section className="py-16 bg-light">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-primary mb-4">
              Otras formas de contactarnos
            </h2>
            <p className="text-gray-600">
              Elige el método que más te convenga para <Link to="/servicios" className="text-gray-600 hover:text-accent transition-colors underline">solicitar tu presupuesto de pintura</Link>
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-6">
            {/* Llamada */}
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-shadow text-center"
            >
              <div className="w-20 h-20 bg-primary rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-phone-line text-4xl text-white"></i>
              </div>
              <h3 className="text-xl font-bold text-primary mb-3">Llámanos</h3>
              <p className="text-gray-600 mb-4">
                Habla directamente con nosotros
              </p>
              <a
                href="tel:+34690220944"
                className="text-2xl font-bold text-accent hover:text-accent/80 cursor-pointer"
              >
                690 22 09 44
              </a>
              <p className="text-sm text-gray-500 mt-2">L-V: 8:00-20:00, S: 9:00-14:00</p>
            </motion.div>

            {/* WhatsApp */}
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: 0.1 }}
              className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-shadow text-center"
            >
              <div className="w-20 h-20 bg-accent rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-whatsapp-line text-4xl text-white"></i>
              </div>
              <h3 className="text-xl font-bold text-primary mb-3">WhatsApp</h3>
              <p className="text-gray-600 mb-4">
                Envía fotos y recibe respuesta rápida
              </p>
              <a
                href="https://wa.me/34690220944"
                target="_blank"
                rel="noopener noreferrer"
                className="whitespace-nowrap inline-block px-6 py-3 bg-accent text-white rounded-full font-semibold hover:bg-accent/90 transition-all cursor-pointer"
              >
                Abrir WhatsApp
              </a>
              <p className="text-sm text-gray-500 mt-2">Respuesta rápida</p>
            </motion.div>

            {/* Email */}
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: 0.2 }}
              className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-shadow text-center"
            >
              <div className="w-20 h-20 bg-primary rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-mail-line text-4xl text-white"></i>
              </div>
              <h3 className="text-xl font-bold text-primary mb-3">Formulario</h3>
              <p className="text-gray-600 mb-4">
                Usa el formulario de arriba
              </p>
              <button
                onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
                className="whitespace-nowrap inline-block px-6 py-3 bg-primary text-white rounded-full font-semibold hover:bg-primary/90 transition-all cursor-pointer"
              >
                Ir al formulario
              </button>
              <p className="text-sm text-gray-500 mt-2">Respuesta en 24-48h</p>
            </motion.div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default ContactoPage;
